import React, { useMemo } from 'react';
import { ServiceRequest } from './steps/ServiceRequest';
import { Stepper } from '@shared/components/Stepper';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { GuestPortalTopnav } from '../../Topnav';
import { AnnouncementBanner } from '../../AnnouncementBanner';
import { VerifyIdentity } from './steps/VerifyIdentity';
import { ConfirmOTP } from './steps/ConfirmOTP';
import { Confirmation } from './steps/Confirmation';
import { ReviewPayment } from './steps/ReviewPayment';
import { useTranslation } from 'react-i18next';

export const ServiceRequestLanding = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const steps = useMemo(() => [
    {
      id: 1,
      title: t("Verify Identity"),
      slug: 'verify-identity',
      component: <VerifyIdentity />
    },
    {
      id: 2,
      title: t("Confirm OTP"),
      slug: 'confirm-otp',
      component: <ConfirmOTP />
    },
    {
      id: 3,
      title: t("Service Request"),
      slug: 'service-request',
      component: <ServiceRequest />
    },
    {
      id: 4,
      title: t("Review & Payment"),
      slug: 'review-payment',
      component: <ReviewPayment />
    },
    {
      id: 5,
      title: t("Confirmation"),
      slug: 'confirmation',
      component: <Confirmation />
    }
  ], [t]);

  return (
    <div className="min-h-screen flex flex-col bg-[#f8f9fa] font-sans">
      <div className="shrink-0 sticky top-0 z-50 bg-white shadow-sm">
        <GuestPortalTopnav />
        {/* Banner */}
        <AnnouncementBanner />
      </div>
      
      {/* Container */}
      <div className="flex-1 w-full p-4 md:p-8 mt-4">
        {/* Main Title */}
        <div className="mb-8 px-4">
          <h1 className="text-2xl font-bold text-gray-900 ">{t("Service Request")}</h1>
          <p className="text-gray-500">{t("Verify your account and submit a utility service request.")}</p>
        </div>

        {/* Shared Stepper */}
        <Stepper
          steps={steps}
          enableRouting={true}
          storageKey="guest-service-request-stepper"
          autoSave={false}
          persistProgress={false}
          allowStepClick={false}
        />
      </div>
    </div>
  );
};
